import {
  ERPSeedless,
  ERPRJL,
  ERPUnity,
  ERPOdoo,
  ERPZertus
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";

import CreateProductPage from "./CreateProductPage";
import ProductCategoriesPage from "./ProductCategoriesPage";
import ProductDeliveryRoute from "./ProductDeliveryRoute";
import ProductDetailsPage from "./ProductDetailsPage";

const AdminCreateProductMenu: IRoute[] = [
  {
    exact: true,
    path: "/admin/products/create",
    pageComponent: CreateProductPage,
    title: "%PRODUCT% Details",
    menuType: "ADMIN_CREATE_PRODUCT",
    context: "CREATE_EDIT_PRODUCT",
    permissions: [ "create-product" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPOdoo,
      ERPZertus
    ]
  },
  {
    exact: true,
    title: "Categories",
    menuType: "ADMIN_CREATE_PRODUCT",
    context: "CREATE_EDIT_PRODUCT",
    permissions: [ "create-product" ],
    disabled: true,
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ]
  },
  {
    exact: true,
    title: "Prices",
    menuType: "ADMIN_CREATE_PRODUCT",
    context: "CREATE_EDIT_PRODUCT",
    permissions: [ "create-product" ],
    disabled: true,
    privateRoute: true,
    erp: [ ERPSeedless, ERPZertus ]
  },
  {
    exact: true,
    title: "Delivery Days",
    menuType: "ADMIN_CREATE_PRODUCT",
    context: "CREATE_EDIT_PRODUCT",
    permissions: [ "create-product" ],
    disabled: true
  }
];

const AdminEditProductMenu: IRoute[] = [
  {
    exact: true,
    path: "/admin/products/:productId/details",
    pageComponent: ProductDetailsPage,
    title: "%PRODUCT% Details",
    menuType: "ADMIN_EDIT_PRODUCT",
    context: "CREATE_EDIT_PRODUCT",
    permissions: [ "amend-product" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo
    ]
  },
  {
    exact: true,
    title: "Categories",
    path: "/admin/products/:productId/categories",
    pageComponent: ProductCategoriesPage,
    menuType: "ADMIN_EDIT_PRODUCT",
    context: "CREATE_EDIT_PRODUCT",
    permissions: [ "amend-product" ],
    privateRoute: true,
    erp: [
      ERPSeedless,
      ERPRJL,
      ERPUnity,
      ERPOdoo,
      ERPZertus
    ]
  },
  {
    exact: true,
    title: "Delivery Days",
    path: "/admin/products/:productId/delivery-routes",
    pageComponent: ProductDeliveryRoute,
    menuType: "ADMIN_EDIT_PRODUCT",
    context: "CREATE_EDIT_PRODUCT",
    permissions: [ "amend-product" ]
  }
];

export default [ ...AdminCreateProductMenu, ...AdminEditProductMenu ];
